module.exports = __webpack_public_path__ + "img/尴尬.0658668e.png";